import { Route } from '@angular/router';
import { PseudoModuleRoutes } from 'src/app/constants';
import { PrivilegeLevels } from 'src/app/roles';
import { ICS_CDK_AUTH_GUARD } from '@ics-cdk/authentication';
import { IcsCdkAuthorizationGuard } from '@ics-cdk/core/authorization';
import { buildMessengerRoutes } from '@ics-angular/messenger';

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./components/dashboard/dashboard.component').then(
        c => c.DashboardComponent
      ),
    canActivate: [
      ICS_CDK_AUTH_GUARD,
      IcsCdkAuthorizationGuard(PrivilegeLevels.ReadAccess),
    ],
  },
  {
    path: PseudoModuleRoutes.core,
    loadChildren: () =>
      import('./modules/management-core/routes').then(m => m.routes),
    canActivate: [
      ICS_CDK_AUTH_GUARD,
      IcsCdkAuthorizationGuard(PrivilegeLevels.ReadAccess),
    ],
    title: 'ui.routing.core',
  },
  {
    path: PseudoModuleRoutes.tms,
    loadChildren: () => import('./modules/tms/routes').then(m => m.routes),
    canActivate: [
      ICS_CDK_AUTH_GUARD,
      IcsCdkAuthorizationGuard(PrivilegeLevels.TmsAccess),
    ],
    title: 'ui.routing.tms',
  },
  {
    path: PseudoModuleRoutes.lvs,
    loadChildren: () => import('./modules/lvs/routes').then(m => m.routes),
    canActivate: [
      ICS_CDK_AUTH_GUARD,
      IcsCdkAuthorizationGuard(PrivilegeLevels.LvsAccess),
    ],
    title: 'ui.routing.lvs',
  },
  {
    path: PseudoModuleRoutes.admin,
    loadChildren: () => import('./modules/admin/routes').then(m => m.routes),
    canActivate: [
      ICS_CDK_AUTH_GUARD,
      IcsCdkAuthorizationGuard(PrivilegeLevels.Admin),
    ],
    canActivateChild: [IcsCdkAuthorizationGuard(PrivilegeLevels.Admin)],
    title: 'ui.routing.admin',
  },
  ...buildMessengerRoutes(),
  {
    // No menu entry on purpose, the backend redirects /hangfire here
    path: 'hangfire-anmeldung',
    loadComponent: () =>
      import('./components/hangfire-login/hangfire-login.component').then(
        c => c.HangfireLoginComponent
      ),
    canActivate: [ICS_CDK_AUTH_GUARD],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./components/page-not-found/page-not-found.component').then(
        c => c.PageNotFoundComponent
      ),
  },
];
